module.exports = __webpack_public_path__ + "static/media/playstation.4b19d360.svg";